export default __webpack_public_path__ + "static/media/divider_ellipse.3a361070.png";